// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"c73bccda","432":"f059a36a","540":"15c402ab","899":"6df2f65c"}[chunkId] + ".chunk.js";
};